// extracted by mini-css-extract-plugin
export default {"sidebar":"PlatformSidebar_sidebar__2K5Tb","sidebar_menu":"PlatformSidebar_sidebar_menu__Kfk9o","sidebar_menu_active":"PlatformSidebar_sidebar_menu_active__rH75a"};